function get(name:string){
    let arr=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search)
    if(arr) return decodeURIComponent(arr[1]);
}

export default get